// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorBoundary_wrapper__TqFvc","error":"ErrorBoundary_error__QseL9"};